import { APIClient } from '@frontend/api-utils';

const endpoint = '/workflow-service/api/v1';
export class WorkflowActionClient extends APIClient {
    public static async fetchWorkflowActions(): Promise<{ [key: string]: string }> {
        const response = await this.fetch(`${endpoint}/workflow-actions`);
        return await this.handleResponse(response);
    }
}
